import React from 'react';
//dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
import { CheckboxGroup } from '@swiggy-private/dls-web-core/dist/components/Checkbox';
//constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
//styles
import styles from './Filters.module.scss';
//stores
import useSearchCampaignStore from '@/stores/SearchCampaign';
//defs
import { CampaignSearchStatus } from '@/defs/CampaignSearch';
const checkboxItems = [
    { label: 'Active', value: CampaignSearchStatus.ACTIVE },
    { label: 'Booked', value: CampaignSearchStatus.BOOKED },
    { label: 'Stopped', value: CampaignSearchStatus.STOPPED },
    { label: 'Exhausted', value: CampaignSearchStatus.EXHAUSTED },
    { label: 'Expired', value: CampaignSearchStatus.EXPIRED },
];
const CampaignStatus = () => {
    const { status, setStatus } = useSearchCampaignStore((state) => ({
        status: state.statusFilter.status,
        setStatus: state.statusFilter.setStatus,
    }));
    const onChange = (value) => {
        setStatus(value);
    };
    return (React.createElement("div", null,
        React.createElement(Text, { className: styles.filterLabel, variant: DlsFontVariants.body_B1_Med, color: DlsColorTokens.text_Highest_Emphasis }, "Status"),
        React.createElement("div", { className: styles.cbGroup },
            React.createElement(CheckboxGroup, { name: "status-cb", value: status, items: checkboxItems, onChange: (value) => onChange(value) }))));
};
export default CampaignStatus;
